import React, { useEffect, useState } from 'react'
import { connect } from "react-redux"
import withStyles from '@material-ui/core/styles/withStyles'
import { CollateralStyles } from '../../CollateralStyles'
import { useTranslation } from 'react-i18next'
import Modal from 'antd/es/modal';
import UseForm from '../../../common/UseForm'
import DataTable from 'react-data-table-component'
import { customStyleSecondary } from '../../../common/CommonStyles'
import {  Container,  Grid} from '@material-ui/core'
import { Backdrop, CircularProgress } from '@material-ui/core'

const InvoiceRigthsTab = ({ classes, ...props }) => {
    const { t } = useTranslation()
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const initialSaveSubStageBody = {
        BranchOfficeId: props.match.params.branchOfficeId,
        WOID:  props.match.params.woid,
        ProcedureID: "",
        Amount: 0,
        FormFile: {}
    }

    const {
        resetForm
    } = UseForm(initialSaveSubStageBody)

    useEffect(() => {
        handleOpenBackdrop()
        props.actions.fetch_Rigths_Per_Order(props.userLanguage, props.userToken, props.match.params.woid, onError, onSuccess)
    }, [])// eslint-disable-line react-hooks/exhaustive-deps



    const onSuccess = (res) => {
        handleCloseBackdrop()
        if (res.success === false) {

        }
    }


 

    //*First Render Functions
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: err.response.errors[0]
                    })
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }



    const columns = [
        {
            name: t('collateralDetails.rigthsFileName'),
            selector: 'fileName',
            sortable: true,
            with: '300px',
            cell: row => row.fileName
        },
        {
            name: t('collateralDetails.rigthsName'),
            selector: 'description',
            sortable: true,
            with: '350px',
            cell: row => row.description
        },
        {
            name: t('collateralDetails.rigthsDate'),
            selector: 'date',
            width: '200px',
            sortable: true,
            cell: row => row.date
        },
        {
            name: t('common.amount'),
            selector: 'amount',
            width: '180px',
            sortable: true,
            cell: row => row.amount
        }
    ]

 

    return (
        <div>
                <Container className={classes.generalBorder}>
                    <Backdrop className={classes.backdrop} open={openBackdrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <br />
                    <DataTable
                        noHeader
                        columns={columns}
                        customStyles={customStyleSecondary}
                        data={props.rigthsPerOrder}
                        highlightOnHover
                        defaultSortField="date"
                        dense
                        responsive
                        striped
                        pointerOnHover
                        pagination
                        paginationComponentOptions={paginationOptions}
                        noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                    />
                    {
                        props.rigthsPerOrder && props.rigthsPerOrder.length < 1 && (
                            <Grid container item xs={12}><br /></Grid>
                        )
                    }
                </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    rigthsPerOrder: state.CollateralReducer.rigthsPerOrder,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

export default connect(mapStateToProps)(withStyles(CollateralStyles)(InvoiceRigthsTab))